import { theme, Typography } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddressesList } from "../../../shared/container/Addresses/AddressesList/AddressesList";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";

export const PrincipalAddresses = () => {
  const {} = useSelector(state => state.addresses);

  const { principal, loading } = useSelector(state => state.principal);

  const { id } = useParams();

  const [e, et] = useState(false);

  const dispatch = useDispatch();

  const {
    token: { colorPrimary },
  } = theme.useToken();


  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.principals(id).addresses.title}
      </Typography.Title>
      {principal._id !== undefined && <AddressesList principal={principal} type={'postal'} />}
    </>
  );
};
